@if (isOpen) {
  <div class="inventory-item-history-panel__backdrop" role="presentation" (click)="closed.emit()"></div>

  <aside
    class="inventory-item-history-panel"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'COMPONENTS.INVENTORY_ITEM_OVERVIEW.HISTORY.TITLE' | translate"
  >
    <header class="inventory-item-history-panel__header">
      <div class="inventory-item-history-panel__header-copy">
        <h3 class="inventory-item-history-panel__title">
          {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.HISTORY.TITLE' | translate }}
        </h3>
        <p class="inventory-item-history-panel__subtitle">{{ itemTitle }}</p>
      </div>

      <button type="button" class="inventory-item-history-panel__close" (click)="closed.emit()">
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M5 5l10 10M15 5 5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </button>
    </header>

    <div class="inventory-item-history-panel__body">
      @if (historyEntries.length) {
        <div class="inventory-item-history-panel__list">
          @for (entry of historyEntries; track entry.id) {
            <article class="inventory-item-history-panel__item">
              <div class="inventory-item-history-panel__item-marker" aria-hidden="true">
                <span class="inventory-item-history-panel__item-dot" [ngClass]="entry.dotClass"></span>
              </div>

              <div class="inventory-item-history-panel__item-head">
                <div>
                  <p class="inventory-item-history-panel__item-title">
                    {{ entry.summaryKey | translate: entry.summaryParams }}
                  </p>
                  <p class="inventory-item-history-panel__item-person">{{ entry.initiator }}</p>
                </div>

                <div class="inventory-item-history-panel__item-meta">
                  <p class="inventory-item-history-panel__item-date">{{ entry.createdAt | date:'dd.MM.yyyy HH:mm' }}</p>
                  @if (entry.sourceLabelKey) {
                    <span class="inventory-item-history-panel__source-badge">
                      {{ entry.sourceLabelKey | translate }}
                    </span>
                  }
                </div>
              </div>

              @if (entry.componentDetails) {
                <div class="inventory-item-history-panel__item-body">
                  @if (entry.componentDetails.hasPreviousQuantity && entry.componentDetails.hasQuantity) {
                    <div class="inventory-item-history-panel__diff-row">
                      <p class="inventory-item-history-panel__diff-label">
                        {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.HISTORY.QUANTITY_LABEL' | translate }}
                      </p>
                      <p class="inventory-item-history-panel__diff-value">
                        <span class="inventory-item-history-panel__diff-value inventory-item-history-panel__diff-value--old">
                          {{ entry.componentDetails.previousQuantity | number: '1.0-4' }}
                        </span>
                        <span class="inventory-item-history-panel__diff-arrow">→</span>
                        <span class="inventory-item-history-panel__diff-value inventory-item-history-panel__diff-value--new">
                          {{ entry.componentDetails.quantity | number: '1.0-4' }}
                        </span>
                      </p>
                    </div>
                  } @else if (entry.componentDetails.hasQuantity) {
                    <div class="inventory-item-history-panel__diff-row">
                      <p class="inventory-item-history-panel__diff-label">
                        {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.HISTORY.QUANTITY_LABEL' | translate }}
                      </p>
                      <p class="inventory-item-history-panel__diff-value">
                        <span class="inventory-item-history-panel__diff-value inventory-item-history-panel__diff-value--new">
                          {{ entry.componentDetails.quantity | number: '1.0-4' }}
                        </span>
                      </p>
                    </div>
                  }
                </div>
              }

              @if (entry.diffRows.length) {
                <div class="inventory-item-history-panel__item-body">
                  @for (row of entry.diffRows; track row.labelKey + row.oldValue + row.newValue) {
                    <div class="inventory-item-history-panel__diff-row">
                      <p class="inventory-item-history-panel__diff-label">{{ row.labelKey | translate }}</p>
                      <p class="inventory-item-history-panel__diff-value">
                        @if (row.showOldValue && row.oldValue) {
                          <span class="inventory-item-history-panel__diff-value inventory-item-history-panel__diff-value--old">
                            @if (row.oldValue.translationKey) {
                              {{ row.oldValue.translationKey | translate }}
                            } @else {
                              {{ row.oldValue.text }}
                            }
                          </span>
                          <span class="inventory-item-history-panel__diff-arrow">→</span>
                        }
                        <span class="inventory-item-history-panel__diff-value inventory-item-history-panel__diff-value--new">
                          @if (row.newValue.translationKey) {
                            {{ row.newValue.translationKey | translate }}
                          } @else {
                            {{ row.newValue.text }}
                          }
                        </span>
                      </p>
                    </div>
                  }
                </div>
              }
            </article>
          }
        </div>
      } @else {
        <div class="inventory-item-history-panel__empty">
          {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.HISTORY.EMPTY' | translate }}
        </div>
      }
    </div>
  </aside>
}
